<template>
  <div class="download">
		<el-tooltip class="item" effect="dark" v-model="visible" content="若已安装，点击右上角选择浏览器打开" placement="top-end">
      <span class="tooltip"></span>
    </el-tooltip>
    <div class="app">
      <img src="~@/assets/images/logo_easy.png" alt="" />
      <img src="~@/assets/images/logo_ls.png" alt="" />
    </div>
    <div class="desc">出于安全考虑，请使用批发易或零售通APP扫码</div>
    <div class="footer">
      <button class="button" @click="openApp('pfbossapp')">打开森果批发易</button>
      <button class="button" @click="openApp('newlsapp')">打开森果零售通</button>
    </div>
  </div>
</template>

<script>
import subDomain from "@/config/systemDomain";
import CallApp from 'callapp-lib';
import { isWX } from "@/assets/js/util"

export default {
  data() {
    return {
			visible: false
		};
  },
  created() {
		this.visible = isWX()
	},
	computed: {
		
	},
  methods: {
		openApp(type) {
			// 微信环境下不支持网页唤醒app，需要使用微信的方案(因为开放平台和公证号的认证主体不一致，安全域名暂时绑不上)
			if( isWX()) {
				this.goUrl(type)
				return
			}
			
			const options = {
        scheme: {
          protocol: type === "pfbossapp" ? 'senguopfbossapp' : 'senguocashiermanageapp'
        },
        intent: {
          package: type === "pfbossapp" ? 'cc.senguo.secretary' : 'cc.senguo.cashiermanage',
          scheme: type === "pfbossapp" ? 'senguopfbossapp' : 'cashiermanageapp'
        },
				appstore: type === "pfbossapp" ? "https://apps.apple.com/cn/app/%E6%A3%AE%E6%9E%9C%E6%89%B9%E5%8F%91%E6%98%93/id1266624830" : 'https://apps.apple.com/cn/app/%E6%A3%AE%E6%9E%9C%E9%9B%B6%E5%94%AE%E9%80%9A/id1493885127',
      }
			const callLib = new CallApp(options);
			callLib.open({
				callback: this.goUrl(type)
			})
		},

    goUrl(type) {
      if (type == "pfbossapp") {
        window.location.href =
          subDomain.pf_domain + "/download/mobileDownload?tab=1";
      } else {
        window.location.href =
          subDomain.new_retail_domain + "/admin#/downloadNavigation";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.download {
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 700px;
  height: 100%;
  margin: 0 auto;
  overflow-y: auto;
  text-align: center;

	.tooltip {
		position: absolute;
		right: 20px;
		top: 5px;
	}

  &::-webkit-scrollbar {
    display: none;
  }
  .app {
    margin-top: 36%;
    img {
      width: 80px;
      height: 80px;
      border-radius: 10px;
      &:first-child {
        margin-right: 30px;
      }
    }
  }
  .desc {
    margin-top: 50px;
    color: #333;
  }
  .footer {
    margin-top: 50px;
    .button {
      width: 70%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      letter-spacing: 0.24px;
      font-weight: 700;
      color: #fff;
      // box-shadow: 0 2px 2px 2px #009688;
      background: linear-gradient(180deg, #14cc9b, #009688);
      border-radius: 10px;
      border: none;
      margin-bottom: 20px;
    }
  }
}
</style>

